import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=4aa5d532&"
import script from "./Trades.vue?vue&type=script&lang=js&"
export * from "./Trades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports